import React from 'react'
import Helmet from 'react-helmet'
import Breadcrumb from '../../components/breadcrumb/breadcrumb'
import Hero from '../../components/hero-v2/hero'
import Layout from '../../components/layouts/layout'
import { AgenciasInfo, CanalesInfo, NotificacionYDocumentosOficiales } from '../../components/canales-de-atencion'

const CanalesDeAtencion = () => {
  const titlesBreadcrumb = {
    titleFinal: 'Canales de atención'
  }

  return (
    <Layout>
      <Helmet>
        <title>Contacto y Soporte: Canales de Atención | Prima AFP</title>
        <meta name='title' content='Contacto y Soporte: Canales de Atención | Prima AFP' data-react-helmet="true" />
        <meta name='description' content='Enterate aquí sobre los canales de atención de Prima AFP. Desde el Horario de atención, la dirección de nuestras oficinas y los números de contacto.' data-react-helmet="true" />
      </Helmet>

      <Hero
        title="Canales de atención"
        image={'sobre-prima-afp/canales-de-atencion/banner-canales-de-atencion-desktop.svg'}
        imageMobile={'sobre-prima-afp/canales-de-atencion/banner-canales-de-atencion-mobile.svg'}
        className={`bg-orange-4`}
      />

      <Breadcrumb titlesBreadcrumb={titlesBreadcrumb} />

      <div className='tw-mt-10 tw-mb-6 tw-mb-10@lg center'>
        <h3 className='font-family-secondary c-gray--4 fw-4 fw-7@lg tw-f-20 tw-f-24@lg'>
          Canales de Atención
        </h3>
      </div>

      <section className='tw-pt-12 tw-pt-20@lg bg-gray-6'>
        <CanalesInfo />
      </section>

      <section className='tw-pt-12 tw-pt-20@lg bg-white'>
        <AgenciasInfo />
      </section>

      <section className='tw-pt-12 tw-pt-20@lg tw-pb-12 tw-pb-20@lg bg-white'>
        <NotificacionYDocumentosOficiales />
      </section>
    </Layout>
  )
};

export default CanalesDeAtencion;
